import mapProps from '../scripts/utils/map-props';
import Radio from './radio';

export default mapProps(
  [
    'checked',
  ],
  {
    model: {
      prop: 'checked',
      event: 'change',
    },
  }
)(Radio);
